import React from 'react';
import logoIcon from '../../../public/assets/icons/192x192.png';

const SplashContent = () => {
  return (
    <div className="flex flex-col items-center gap-3">
      <img
        src={logoIcon}
        alt="logo"
        className="h-32 w-32 animate-pulse"
      />

      <div className="text-primary font-semibold text-base">
        Kea Expense
      </div>
    </div>
  );
};

export default SplashContent;